export type TranslationDictionary = Record<string, Record<string, string>>;

export function mergeTranslations(base: TranslationDictionary, next: TranslationDictionary): TranslationDictionary {
  const merged = { ...base };

  for (const [nextLocale, dictionary] of Object.entries(next)) {
    merged[nextLocale] = {
      ...merged[nextLocale],
      ...dictionary,
    };
  }

  return merged;
}
